import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const SidebarSection = ({ children, heading }) => {
	return (
		<Stack spacing={1}>
			<Typography variant="h6" color="text.primary">
				{heading}
			</Typography>
			<Paper sx={{ px: 2, py: 1, border: 1, borderColor: (theme) => theme.palette.divider, borderRadius: 0.75 }}>
				{children}
			</Paper>
		</Stack>
	);
};

SidebarSection.propTypes = {
	children: PropTypes.node,
	heading: PropTypes.string,
};

export default SidebarSection;
